<template>
  <div>
    <section>
      <div v-for="tag in attribute_tags" :key="tag.id" class="flex flex-row">
        <h2 class="font-bold mr-2"> {{ tag.tag }}: </h2>
        <h3>{{ getProductAttribute(tag.slug) }}</h3>
      </div>
    </section>
  </div>
</template>

<script>
export default {

  props: ['attributes', 'attribute_tags'],

  methods: {
    getProductAttribute(tag) {
      return this.attributes.find((attribute) => attribute.attribute_tag === tag).attribute_value;
    },
  },
};
</script>
